module.exports = __webpack_public_path__ + "img/21D7F86DE91C1A503C8161E6E5F0B7BA.21d7f86d.png";